import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { withPrefix } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { ReferenciaPlantillaContenido } from "../../../interfaces/ReferenciaPlantillaContenido";
import CardClub from "../../atoms/card-club/cardClub";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./clubCarousel.scss";

const ClubCarousel = (props: ReferenciaContenido) => {
  const {
    tituloGeneral,
    referenciaPlantillaContenido,
    tituloBoton,
    redireccionBoton,
    nombreCategoria,
  } = props;

  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();
  const [clubs, setClubs] = useState<ReferenciaPlantillaContenido[]>([]);
  const [slidesToScroll, setSlidesToScroll] = useState(3);
  const { window, isBrowser } = useBrowserMode();

  useEffect(() => {
    if (isBrowser) {
      const refcont = referenciaPlantillaContenido.filter(club => club.imagenPrincipal != null);
      if (window.screen.width < 501) {
        setClubs(refcont.slice(0, 4));
        setSlidesToScroll(1);
      } else if (window.screen.width < 963) {
        setClubs(refcont.slice(0, 6));
      } else if (window.screen.width < 1251) {
        setSlidesToScroll(2);
        setClubs(refcont);
      } else {
        setSlidesToScroll(3);
        setClubs(refcont);
      }
    }
  }, [referenciaPlantillaContenido]);

  const goToNext = () => {
    slider.slickGoTo(sliderIndex + slidesToScroll);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - slidesToScroll);
  };

  const isActiveNext = (_true: any, _false: any) => {
    return sliderIndex < referenciaPlantillaContenido.length - slidesToScroll
      ? _true
      : _false;
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  const settings = {
    arrows: false,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3.75,
    slidesToScroll: 3,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
    responsive: [
      {
        breakpoint: 1370,
        settings: {
          centerMode: false,
          slidesToShow: 3.4,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1250,
        settings: {
          centerMode: false,
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 963,
        settings: {
          centerMode: false,
          slidesToShow: 2.25,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 801,
        settings: {
          centerMode: false,
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 340,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="m-club-carousel">
      <div className="m-club-carousel__title-section">
        <h2 className="m-club-carousel__title-section__title">
          {tituloGeneral}
        </h2>
        <a
          className={`m-club-carousel__title-section__see-all gtm${normalizeTwoWords(
            nombreCategoria
          )}${normalizeTwoWords(tituloGeneral)}${normalizeTwoWords(
            tituloBoton
          )}`}
          href={withPrefix(redireccionBoton)}
        >
          {tituloBoton}
        </a>
      </div>
      <div className="m-club-carousel__carousel">
        <div className="m-club-carousel__carousel__shadow"></div>
        <Slider ref={(_slider) => setSlider(_slider)} {...settings}>
          {clubs.length > 0 &&
            clubs.map((club, idx) => {
              return (
                <a
                  key={idx}
                  className={`books-desktop gtm${normalizeTwoWords(
                    props.nombreCategoria
                  )}ClicClubes${normalizeTwoWords(
                    tituloGeneral
                  )}${normalizeTwoWords(club.tituloBanner)}`}
                  href={withPrefix(club.redireccionBoton)}
                  target="_self"
                >
                  <CardClub club={club} key={idx} />
                </a>
              );
            })}
        </Slider>
        {clubs.length > 3 && (
          <>
            <div
              className="arrow-content arrow-content__left"
              onClick={isActiveBack(goToBack, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveBack(
                      "arrow icon-chevron-left active",
                      "arrow icon-chevron-left"
                    )}
                  />
                </div>
              </div>
            </div>
            <div
              className="arrow-content arrow-content__right"
              onClick={isActiveNext(goToNext, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveNext(
                      "arrow icon-chevron-right active",
                      "arrow icon-chevron-right"
                    )}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ClubCarousel;
